/**
 * Image Hotspot Content Type
 * Image with clickable hotspots that reveal content, optionally with supplementary content
 */

// Package version
import pkgJson from '../package.json';
export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

// Schema and types
export {
    imageHotspotSchema,
    defaultImageHotspotConfig,
    defaultImageHotspotData,
    defaultImageHotspotI18n,
    type ImageHotspotContent,
    type ImageHotspotData,
    type ImageHotspotConfig,
    type ImageHotspotLayoutConfig,
    type PlayerViewLayout,
} from './schema';

// Components
export { ImageHotspotEdit, type ImageHotspotEditProps } from './ImageHotspotEdit';
export { ImageHotspotPlayer, type ImageHotspotPlayerProps } from './ImageHotspotPlayer';

// Default export
export { imageHotspotSchema as default } from './schema';

export { imageHotspotValidator } from './validator';

export { countImageHotspotQuestions, imageHotspotQuestionCounter } from './questionCount';
